import { Dispatch } from "react";
import {Types} from "./PayRollIncidentContext";

export const payrollIncidentModal = ({_id = "",payRollIncident={},editView="",modalPayRollIncendent = true}:any, dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.MODAL_PAYROLL_INCIDENT,
       payload:{
        _id,
        editView,
        payRollIncident,
        modalPayRollIncendent
       } 
    })
}

export const closeModalPayrollIncident = ({_id="",payRollIncident={},editView="", modalPayRollIncendent = false}:any, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_PAYROLL_INCIDENT_MODAL,
        payload: {
            _id,
            editView,
            payRollIncident,
            modalPayRollIncendent           
        }
    })
}